export default {
  about: '关于我们',
  help: '帮助中心',
  contact: '联系我们',
  highpay: '高薪诚聘',
  agreement: '服务协议',
  payment: '支付方式',
  cooperation: '展会合作',
  ICP_recordNum: 'ICP备案号:浙ICP备18015679号',
  networkSecurity: '浙公网安备 33011002013432号',

  us_collaborate: '和我们合作',
  customer: '在线客服',
  booth_consult: '展位咨询',
  viewer_consult: '观众咨询',
  work_time: '周一至周日',
  work_time2: '周一至周五',
  friendship_link: '友情链接：(互换友链请加QQ: 61882907)',

  WeChatofficial: '微信公众号',
  WeChat_applet: '微信小程序',
  desc: '请使用手机微信扫码关注',
  scan_follow: '扫码关注公众号',
  scan_openApplet: '扫码打开小程序'
}
